import React, { useLayoutEffect } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';

import BreadCrumb from 'jbc-front/components/BreadCrumb';
import { CLIENT_PAYROLL_RULES_GROUP_NEW, CLIENT_SETTINGS, CLIENT_ALLOWANCE_ITEMS } from 'src/constants/EndpointUrls';
import { REDUCER_NAME } from 'src/reducers/clients/payrollRulesGroups';
import { setList } from 'src/reducers/common/listReducer';
import { LinkBtn } from 'src/buttons';
import { AddFile } from 'jbc-front/components/icons';
import { useTranslation } from 'react-i18next';
import { getItem } from 'src/reducers/common/itemReducer';

import PayrollRulesGroupTable from './containers/PayrollRulesGroupTable';
import styles from './PayrollRulesGroupsList.scss';
import CustomAlert from './components/CustomAlert';

const PayrollRulesGroupsList = ({ clientPayrollRulesGroups, dispatch, warningMessages }) => {
  useLayoutEffect(() => {
    dispatch(setList(REDUCER_NAME, { data: clientPayrollRulesGroups, pageCount: 1 }));
  }, []);

  const { t } = useTranslation();

  return (
    <div>
      <div className="l-main-title-wrap">
        <h2 className="m-title-main">{t('features.PayrollRulesGroups.PayrollRulesGroupsList.salary_rule_group_list')}</h2>
      </div>
      <div className="l-wrap-s l-contents-wrap">
        <div className="u-mb20">
          <BreadCrumb>
            <BreadCrumb.Item label={t('components.SideMenu.SideMenu.setting')} path={CLIENT_SETTINGS} />
            <BreadCrumb.Item label={t('features.PayrollRulesGroups.PayrollRulesGroupsList.salary_rule_group_list')} />
          </BreadCrumb>
        </div>
        <div>
          <div className={styles.description}>
            <p>{t('features.PayrollRulesGroups.PayrollRulesGroupsList.The_items_below_can_be_set')}</p>
            <div className={styles.itemsWrap}>
              <ul className={styles.items}>
                <li>・{t('features.Employees.components.PayrollRulenInfo.cutoff_date')}</li>
                <li>・{t('features.EmployeeAttendances.EmployeeAttendanceDownloadCsvPage.payment_date')}</li>
                <li>・{t('features.PayrollRulesGroups.PayrollRulesGroupsList.prescribed_work_hours_in_1_day')}</li>
                <li>・{t('features.PayrollRulesGroups.PayrollRulesGroupsList.average_designated_working_days_in_one_month')}</li>
                <li>・{t('features.PayrollRulesGroups.PayrollRulesGroupsList.average_designated_working_hours_in_one_month')}</li>
                <li>・{t('features.PayrollRulesGroups.PayrollRulesGroupsList.month_to_use_in_payslip')}</li>
                <li>・{t('features.PayrollRulesGroups.PayrollRulesGroupsList.salary_form_monthly_salary_daily_wage_hourly_wage')}</li>
                <li>・{t('features.PayrollRulesGroups.PayrollRulesGroupsList.provision_and_deduction_items')}</li>
                <li>・{t('features.PayrollRulesGroups.PayrollRulesGroupsList.unit_price_setting')}</li>
              </ul>
              <ul className={styles.notes}>
                <li>
                  ※{t('features.PayrollRulesGroups.PayrollRulesGroupsList.for_provision_items_and_deduction_items')}
                  {t('features.PayrollRulesGroups.PayrollRulesGroupsList.attendance_setting_text_before_link')}
                  <a href={CLIENT_ALLOWANCE_ITEMS} className="u-txt-link">
                    {t('features.PayrollRulesGroups.PayrollRulesGroupsList.attendance_item_setting')}
                  </a>
                  {t('features.PayrollRulesGroups.PayrollRulesGroupsList.attendance_setting_text_after_link')}
                </li>
              </ul>
            </div>
            <p>
              {t(
                'features.PayrollRulesGroups.PayrollRulesGroupsList.You_can_create_multiple_payroll_rule_groups_if_the_rules_are_different_for_each_employee'
              )}
              <br />
              {t(
                'features.PayrollRulesGroups.PayrollRulesGroupsList.Can_create_a_setting_simply_by_copy_all_setting_details_including_provision_and_deduction_setting_and_create'
              )}
              <br />
              {t('features.PayrollRulesGroups.PayrollRulesGroupsList.for_detailed_setting_procedure')}
              <a
                href="https://jobcan-payroll.zendesk.com/hc/ja/articles/360002075234"
                rel="noopener noreferrer"
                target="_blank"
                className="u-txt-link"
              >
                {t('features.PayrollRulesGroups.PayrollRulesGroupsList.Help')}
              </a>
              {t('features.PayrollRulesGroups.PayrollRulesGroupsList.please_take_a_look')}
            </p>
          </div>
          <div>
            {warningMessages.length > 1 && (
              <CustomAlert title={t('features.PayrollRulesGroups.PayrollRulesGroupsList.warning')} warning>
                <ul className="u-mb20">
                  {warningMessages.map(item => (
                    <li key={item} className="u-mb20">
                      {item}
                    </li>
                  ))}
                </ul>
              </CustomAlert>
            )}
          </div>
          <div className={styles.buttons}>
            <div className={styles.create}>
              <LinkBtn
                text={t('features.PayrollRulesGroups.PayrollRulesGroupsList.create_new')}
                href={CLIENT_PAYROLL_RULES_GROUP_NEW}
                icon={<AddFile size={28} />}
              />
            </div>
          </div>
          <div className="l-overflow-scroll u-mt10">
            <PayrollRulesGroupTable />
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  warningMessages: _.get(getItem(REDUCER_NAME, state), 'warningMessages', [])
});

export default connect(mapStateToProps)(PayrollRulesGroupsList);
